module.exports = __webpack_public_path__ + "img/bm.c5a5992f.svg";